import storage from './storage'
const ST_TOKEN_KEY = 'FZN-TOKEN'
type IToken = string

/**
 * 获取用户Token
 * @returns Token
 */
export const getToken = (): IToken => {
  return storage.get(ST_TOKEN_KEY)
}

/**
 * 存储用户Token
 * @param token Token
 */
export const setToken = (token: IToken) => {
  storage.set(ST_TOKEN_KEY, token)
}

/**
 * 移除用户Token
 */
export const removeToken = () => {
  storage.remove(ST_TOKEN_KEY)
}
